import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'assetClass'
})

@Injectable({
    providedIn: 'root'
})

export class AssetClassPipe implements PipeTransform {

    transform(assetClass: string): string | undefined {
        if (assetClass === 'Real Estate') {
            return 'icon.realEstate';
        }
        else if (assetClass === 'Private Equity') {
            return 'icon.privateEquity';
        }
        else if (assetClass === 'Infrastructure') {
            return 'icon.infra';
        }
        else if (assetClass === 'Digital Asset') {
            return 'icon.digitalAsset';
        }
        else if (assetClass === 'Private Credit' || assetClass === 'Credit') {
            return 'icon.privateCredit';
        }
        else if (assetClass === 'Absolute Returns Strategy') {
            return 'icon.ARS';
        }
    }
}